import { QuestionCircleOutlined } from "@ant-design/icons";
import { Button, theme, Tooltip } from "../ui";
import type { AppShellAction } from "./AppShell";

/** A context-bound assistant can supply this control through the shell's setupHelp slot. */
export function AppShellSetupHelp({ label, onClick, disabled }: AppShellAction) {
  const { token } = theme.useToken();
  return (
    <Tooltip title={label}>
      <Button type="text" icon={<QuestionCircleOutlined />} aria-label={label} onClick={onClick} disabled={disabled} style={{ width: token.controlHeight, height: token.controlHeight, paddingInline: 0 }} />
    </Tooltip>
  );
}
